module.exports = __webpack_public_path__ + "assets/icon-x.52c4dff9.svg";